import React from 'react';
import ConfigurationCheckbox from '../../../widgets/ConfigurationCheckbox';
import noop from 'lodash/noop';

const THIRD_PARTY_OFFERS = [
    {
        refValue: 18,
        code: 'enableWeatherGuaranteeBySensibleWeather',
        title: 'Weather Guarantee - powered by Sensible Weather',
        description: 'Email address, credit card, country, and ZIP/postal code must be required.'
    },
    {
        refValue: 19,
        code: 'enableProtectGroupBookingProtection',
        title: 'Booking Protection - powered by Protect Group'
    }
];

const ThirdPartyOffers = ({
    currentConfigCopy = {},
    isDisabled = false,
    registerSection,
    sectionStyleHandler,
    toggleConfigBoolean = noop
}) => {
    return (
        <section
            className="row spark-panel__content"
            ref={registerSection(13)}
            style={sectionStyleHandler(13)}
        >
            <div className="col-xs-12">
                <h4>Third-party Offers</h4>
                <p>
                    Select the offers you want to show on Checkout.
                    These offers <b>must be activated in SynXis CRS</b> to be viewed in your booking engine (Administration > Hotel > Third Party Offer Providers).
                </p>
                {THIRD_PARTY_OFFERS.map((offer, index) => (
                    <ConfigurationCheckbox
                        key={`third-party-offer-${index}`}
                        title={offer.title}
                        ref={registerSection(offer.refValue)}
                        style={sectionStyleHandler(offer.refValue)}
                        isDisabled={isDisabled}
                        code={offer.code}
                        onChange={toggleConfigBoolean}
                        value={currentConfigCopy[offer.code]}
                        desc={offer.description}
                    />
                ))}
            </div>
        </section>
    )
};

export default ThirdPartyOffers;


// WEBPACK FOOTER //
// ./src/components/pages/pages/guestPayment/third-party-offers.js